import {madnes_anim_is_playing, madnes_anim_play} from "../framework/src/engine/madnes/madnes_anims";
import {
    madnes_get_pos_y, madnes_key_exist,
    madnes_set_alpha,
    madnes_set_img_center,
    madnes_set_pos, madnes_set_pos_y, madnes_set_scale, madnes_set_texture
} from "../framework/src/engine/madnes/madnes_object";
import {madnes_audio_play, madnes_audio_stop} from "../framework/src/engine/madnes/madnes_audio";
import {
    madnes_get_atomic_bet,
    madnes_money_to_coin,
    madnes_win_anim_reset,
    bet,
    madnes_set_win, win
} from "../framework/src/engine/madnes/madnes";
import {cylinder_pos} from "./ib27_config";
import {STATES} from "../framework/src/states/states";
import {he, ico_wi, wi, states, reels_lenghts, reels_pos, fps, server_config, wallet, systemConfig} from "../framework/src/engine/madnes/madnes_variables";
import {madnes_add_bitmap_text, madnes_get_text, madnes_set_text} from "../framework/src/engine/madnes/madnes_text";
import {
    madnes_alpha_to,
    madnes_move_to,
    madnes_rem_from_render,
    madnes_scale_to
} from "../framework/src/engine/madnes/madnes_render";
import {ib27_print_reels} from "./ib27_core_printer";
import {ib27_result_control_part_proc_nxt} from "./ib27_core";
import { CONFIG_PARAMS, MODES } from "../framework/src/system/SystemConfig";
import { ib27_replay_mystery_update } from "./ib27_reels";

export function ib27_show_win_sum_start(win_set)
{
    var money = madnes_money_to_coin( win_set.win.toString() );
    var digits = money.toString().length;
    var line = win_set.line*1+1*1;
    var count = win_set.position.length;

    var center = cylinder_pos[1] + ico_wi / 2;

    var top1 = madnes_get_pos_y("reels_bufer_1_TMP" + ( 2 - win_set.position[1][1] ) );
    var top2 = madnes_get_pos_y("reels_bufer_1_S" + ( 2 - win_set.position[1][1] ) );

    var top = ( top1 > top2  ? top1 : top2 );

    if(!madnes_key_exist("win_sum_groups"))
    {
        madnes_add_bitmap_text("win_sum_groups", "font_mystery_wintable", wi / 2, he / 2, money.toString(), 100);
        madnes_set_img_center("win_sum_groups", 0.5, -0.8);
    }
    else
    {
        madnes_set_text("win_sum_groups", money.toString());
    }

    madnes_set_pos("win_sum_groups", center, top + 80);
    madnes_set_alpha("win_sum_groups", 0.4);
    madnes_set_scale("win_sum_groups", 0.4, 0.4);

    madnes_move_to("win_sum_groups", center, top - 40, 600, ib27_show_win_sum_end);
    madnes_alpha_to("win_sum_groups", 1, 600);
    madnes_scale_to("win_sum_groups", 1, 1, 600)
}

function ib27_show_win_sum_end()
{
    setTimeout(function() {
        madnes_set_pos("win_sum_groups", -9999, -9999);
    }, 200);
}














// MYSTERY

var ib27_mystery_win_set = null;
var ib27_mystery_state = 0;
var replayIndex = 0

export function ib27_mystery_start(win_set)
{
    states.setState(STATES.BONUS);
    // madnes_hide_btns();
    if(systemConfig.get(CONFIG_PARAMS.MODE) === MODES.REPLAY) {
        replayIndex = ib27_replay_mystery_update(win_set.win)
    }
    madnes_win_anim_reset();
    ib27_mystery_win_set = win_set;
    ib27_mystery_state = 0;
    ib27_mystery_core();
}

export var ib27_from_mystery = 0;
export function set_ib27_from_mystery(val) {
    ib27_from_mystery = val;
}

function ib27_mystery_core()
{
    switch(ib27_mystery_state)
    {
        case 0:
            madnes_set_pos("mystery_fadeout", 0, 0);
            madnes_set_pos("mystery_selection", 0, 0);

            madnes_set_pos("mystery_result_1_text", 320, 330);
            madnes_set_pos("mystery_result_2_text", 656, 330);
            madnes_set_pos("mystery_result_3_text", 970, 330);

            madnes_set_pos("mystery_result_1", 0, 0);
            madnes_set_pos("mystery_result_2", 0, 0);
            madnes_set_pos("mystery_result_3", 0, 0);

            madnes_set_text("mystery_result_1_text", madnes_get_text("myst1"));
            madnes_set_text("mystery_result_2_text", madnes_get_text("myst2"));
            madnes_set_text("mystery_result_3_text", madnes_get_text("myst3"));

            madnes_set_texture("mystery_result_1", "mystery_red");
            madnes_set_texture("mystery_result_2", "mystery_gold");
            madnes_set_texture("mystery_result_3", "mystery_green");

            madnes_set_pos("mystery_symbol_1", 0, 0);
            madnes_set_pos("mystery_symbol_2", 0, 0);
            madnes_set_pos("mystery_symbol_3", 0, 0);

            madnes_set_pos("mystery_btn_1", 0, 0);
            madnes_set_pos("mystery_btn_text_1", 330, 534);
            madnes_set_pos("mystery_btn_2", 0, 0);
            madnes_set_pos("mystery_btn_text_2", 644, 534);
            madnes_set_pos("mystery_btn_3", 0, 0);
            madnes_set_pos("mystery_btn_text_3", 960, 534);

            madnes_set_pos("mystery_fadeout_aplha", 0, 0);

            madnes_set_alpha("mystery_fadeout", 0);
            madnes_set_alpha("mystery_selection", 0);

            madnes_set_alpha("mystery_result_1_text", 0);
            madnes_set_alpha("mystery_result_2_text", 0);
            madnes_set_alpha("mystery_result_3_text", 0);

            madnes_set_alpha("mystery_result_1", 0);
            madnes_set_alpha("mystery_result_2", 0);
            madnes_set_alpha("mystery_result_3", 0);

            madnes_set_alpha("mystery_symbol_1", 0);
            madnes_set_alpha("mystery_symbol_2", 0);
            madnes_set_alpha("mystery_symbol_3", 0);

            madnes_set_alpha("mystery_btn_1", 0);
            madnes_set_alpha("mystery_btn_text_1", 0);
            madnes_set_alpha("mystery_btn_2", 0);
            madnes_set_alpha("mystery_btn_text_2", 0);
            madnes_set_alpha("mystery_btn_3", 0);
            madnes_set_alpha("mystery_btn_text_3", 0);

            madnes_set_alpha("mystery_fadeout_aplha", 0);

            ib27_mystery_state = 1;

            madnes_alpha_to("mystery_fadeout", 1000, 1, ib27_mystery_core);
            break;

        case 1:
            madnes_audio_play("mystery_selection");


            for(var reel = 0; reel < reels_pos.length; reel++)
            {
                for(var i = 0; i < reels_lenghts[reel]; i++)
                {
                    madnes_set_pos_y("reels_bufer_" + reel + "_" + i, -9999);
                }

                for(var i = 0; i <= 2; i++)
                {
                    madnes_set_pos_y("reels_bufer_" + reel + "_S" + i, -9999);
                }

                for(var i = 0; i <= 2; i++)
                {
                    madnes_set_pos_y("reels_bufer_" + reel + "_TMP" + i, -9999);
                }
            }


            madnes_alpha_to("mystery_selection", 1, 1000);

            madnes_alpha_to("mystery_result_1", 1, 1000);
            madnes_alpha_to("mystery_result_2", 1, 1000);
            madnes_alpha_to("mystery_result_3", 1, 1000);

            madnes_alpha_to("mystery_symbol_1", 1, 1000);
            madnes_alpha_to("mystery_symbol_2", 1, 1000);
            madnes_alpha_to("mystery_symbol_3", 1, 1000);

            madnes_alpha_to("mystery_btn_1", 1, 1000);
            madnes_alpha_to("mystery_btn_text_1", 1, 1000);
            madnes_alpha_to("mystery_btn_2", 1, 1000);
            madnes_alpha_to("mystery_btn_text_2", 1, 1000);
            madnes_alpha_to("mystery_btn_3", 1, 1000);
            madnes_alpha_to("mystery_btn_text_3", 1, 1000);

            ib27_mystery_state = 2;

            madnes_alpha_to("mystery_fadeout_aplha", 1, 1000, ib27_mystery_core);
            break;

        case 2:
            ib27_mystery_state = 3;
            madnes_alpha_to("mystery_fadeout_aplha", 0, 2000, ib27_mystery_core);
            break;

        case 3:
            madnes_set_texture("mystery_btn_1", "mystery_btn_basic");
            madnes_set_texture("mystery_btn_2", "mystery_btn_basic");
            madnes_set_texture("mystery_btn_3", "mystery_btn_basic");
            ib27_mystery_state = 4;
            // madnes_fullscreen_disable();
            mystery_btn_dn_timer = setTimeout(function() {
                mystery_btn_dn(2);
                mystery_btn_up(2);
            }, systemConfig.get(CONFIG_PARAMS.MODE) === MODES.REPLAY ? 1000 : 36 * 1000);
            break;
        case 5:
            if(
                madnes_anim_is_playing("mystery_symbol_1") ||
                madnes_anim_is_playing("mystery_symbol_2") ||
                madnes_anim_is_playing("mystery_symbol_3")
            )
            {
                setTimeout(ib27_mystery_core, 1000 / fps);
                return;
            }

            ib27_mystery_state = 55;
            setTimeout(ib27_mystery_core, 2600);
            return;

        case 55:
            madnes_audio_stop("mystery_selection");

            madnes_alpha_to("mystery_symbol_1", 0, 500);
            madnes_alpha_to("mystery_symbol_2", 0, 500);
            madnes_alpha_to("mystery_symbol_3", 0, 500);

            madnes_alpha_to("mystery_symbol_boom_1", 0, 500);
            madnes_alpha_to("mystery_symbol_boom_2", 0, 500);
            madnes_alpha_to("mystery_symbol_boom_3", 0, 500);

            madnes_alpha_to("mystery_btn_1", 0, 500);
            madnes_alpha_to("mystery_btn_text_1", 0, 500);
            madnes_alpha_to("mystery_btn_2", 0, 500);
            madnes_alpha_to("mystery_btn_text_2", 0, 500);
            madnes_alpha_to("mystery_btn_3", 0, 500);
            madnes_alpha_to("mystery_btn_text_3", 0, 500);

            madnes_set_texture("mystery_btn_1", "mystery_btn_disabled");
            madnes_set_texture("mystery_btn_2", "mystery_btn_disabled");
            madnes_set_texture("mystery_btn_3", "mystery_btn_disabled");

            madnes_alpha_to("mystery_result_1_text", 0, 500);
            madnes_alpha_to("mystery_result_2_text", 0, 500);
            madnes_alpha_to("mystery_result_3_text", 0, 500);

            madnes_alpha_to("mystery_result_1", 0, 500);
            madnes_alpha_to("mystery_result_2", 0, 500);
            madnes_alpha_to("mystery_result_3", 0, 500);

            /*
            madnes_set_pos("your_mystery_win", wi / 2, he * 0.78);
            madnes_set_pos("your_mystery_sum", wi / 2, he * 0.74);

            madnes_set_text("your_mystery_sum", 0);

            madnes_set_alpha("your_mystery_win", 0);
            madnes_set_alpha("your_mystery_sum", 0);

            ib27_mystery_state = 6;

            madnes_alpha_to("your_mystery_win", 1, 500);
            madnes_alpha_to("your_mystery_sum", 1, 500, ib27_mystery_core);

            madnes_start_coin();
            */
            ib27_mystery_state = 7;
            ib27_from_mystery = 1;
            madnes_mystery_count_max = ib27_mystery_win_set.win;
            ib27_print_reels();
            ib27_mystery_core();
            break;
        case 6:
            /*
            madnes_audio_play("mystery_win");

            ib27_print_reels();

            madnes_mystery_count_pos = 0;
            madnes_mystery_count_max = ib27_mystery_win_set.win;
            madnes_add_to_render(madnes_mystery_count);
            */
            break;
        case 7:
            //madnes_stop_coin();

            ib27_mystery_state = 8;
            /*
            madnes_set_alpha("your_mystery_win", 0);
            madnes_set_alpha("your_mystery_sum", 0);
            */
            madnes_alpha_to("mystery_fadeout", 0, 500, ib27_mystery_core);
            //madnes_set_alpha("mystery_fadeout", 0);
            madnes_alpha_to("mystery_selection", 0, 500);
            //madnes_set_alpha("mystery_selection", 0);

            madnes_set_win(win * 1 + madnes_mystery_count_max * 1); //win = win * 1 + madnes_mystery_count_max * 1;
            //setTimeout(ib27_mystery_core, 100);

            break;
        case 8:
            madnes_set_pos("your_mystery_win", -9999, -9999);
            //madnes_set_pos("your_mystery_sum", -9999, -9999);
            madnes_set_pos("mystery_fadeout", -9999, -9999);
            madnes_set_pos("mystery_selection", -9999, -9999);

            madnes_set_pos("mystery_result_1_text",  -9999, -9999);
            madnes_set_pos("mystery_result_2_text",  -9999, -9999);
            madnes_set_pos("mystery_result_3_text",  -9999, -9999);

            madnes_set_pos("mystery_result_1",  -9999, -9999);
            madnes_set_pos("mystery_result_2",  -9999, -9999);
            madnes_set_pos("mystery_result_3",  -9999, -9999);

            madnes_set_pos("mystery_symbol_1",  -9999, -9999);
            madnes_set_pos("mystery_symbol_2",  -9999, -9999);
            madnes_set_pos("mystery_symbol_3",  -9999, -9999);

            madnes_set_pos("mystery_btn_1",  -9999, -9999);
            madnes_set_pos("mystery_btn_text_1",  -9999, -9999);
            madnes_set_pos("mystery_btn_2",  -9999, -9999);
            madnes_set_pos("mystery_btn_text_2",  -9999, -9999);
            madnes_set_pos("mystery_btn_3",  -9999, -9999);
            madnes_set_pos("mystery_btn_text_3",  -9999, -9999);

            ib27_result_control_part_proc_nxt(ib27_mystery_win_set);

            // madnes_show_btns();

            break;

    }
}


var madnes_mystery_count_pos = 0;
var madnes_mystery_count_max = 0;
var madnes_mystery_count_pos = 0;
function madnes_mystery_count()
{
    var tmp_add = Math.round( madnes_mystery_count_max * ( Math.random() / 60 ) );
    if(tmp_add < 1)
    {
        tmp_add = 1;
    }
    madnes_mystery_count_pos = madnes_mystery_count_pos * 1 + tmp_add;
    if(madnes_mystery_count_pos >= madnes_mystery_count_max)
    {
        madnes_mystery_count_pos = madnes_mystery_count_max;
        madnes_rem_from_render(madnes_mystery_count);
        ib27_mystery_state = 7;
        setTimeout(ib27_mystery_core, 2000);
        madnes_audio_play('remittance_B');
    }
    else
    {
        if(madnes_mystery_count_pos++ % 2 == 0)
        {
            madnes_audio_play('remittance_A');
        }
    }
    //madnes_set_text("your_mystery_sum", madnes_mystery_count_pos);
}

var mystery_btn_dn_timer = null;

export function mystery_btn_dn(pos)
{
    if(ib27_mystery_state == 4)
    {
        ib27_mystery_state = 4.1;

//		var color = "green";
//
//		if(server_config.logic.specifics.specialState.mysteryRewards[server_config.logic.bet_set.indexOf(madnes_get_money_bet(bet))][2] == ib27_mystery_win_set.win)
//		{
//			// red
//			color = "red";
//		}
//		else if(server_config.logic.specifics.specialState.mysteryRewards[server_config.logic.bet_set.indexOf(madnes_get_money_bet(bet))][1] == ib27_mystery_win_set.win)
//		{
//			// gold
//			color = "gold";
//		}
//		else if(server_config.logic.specifics.specialState.mysteryRewards[server_config.logic.bet_set.indexOf(madnes_get_money_bet(bet))][0] == ib27_mystery_win_set.win)
//		{
//			// green
//			color = "green";
//		}

        if(pos == 1)
        {
            madnes_set_texture("mystery_btn_1", "mystery_btn_press");
        }
        else
        {
            madnes_set_texture("mystery_btn_1", "mystery_btn_disabled");
        }
        if(pos == 2)
        {
            madnes_set_texture("mystery_btn_2", "mystery_btn_press");
        }
        else
        {
            madnes_set_texture("mystery_btn_2", "mystery_btn_disabled");
        }
        if(pos == 3)
        {
            madnes_set_texture("mystery_btn_3", "mystery_btn_press");
        }
        else
        {
            madnes_set_texture("mystery_btn_3", "mystery_btn_disabled");
        }

    }
}

export function mystery_btn_up(pos)
{
    
    if(ib27_mystery_state == 4.1)
    {
        ib27_mystery_state = 4.2;

        var color = "green";
        var index = systemConfig.get(CONFIG_PARAMS.MODE) === MODES.REPLAY ? replayIndex : wallet.getBetSet().indexOf(madnes_get_atomic_bet(bet));
        if(server_config.logic.specifics.specialState.mysteryRewards[index]?.[2] == ib27_mystery_win_set.win)
        {
            // red
            color = "red";
        }
        else if(server_config.logic.specifics.specialState.mysteryRewards[index]?.[1] == ib27_mystery_win_set.win)
        {
            // gold
            color = "gold";
        }
        else if(server_config.logic.specifics.specialState.mysteryRewards[index]?.[0] == ib27_mystery_win_set.win)
        {
            // green
            color = "green";
        }

        //console.log(color, server_config.logic.specifics.specialState.mysteryRewards[wallet.getBetSet().indexOf(madnes_get_atomic_bet(bet))], madnes_money_to_coin(ib27_mystery_win_set.win), ib27_mystery_win_set.win);

        if(pos == 1)
        {
            //madnes_set_texture("mystery_btn_1", "mystery_btn_press");
            if(color == "gold")
            {
                madnes_set_texture("mystery_result_1", "mystery_gold");
                madnes_set_texture("mystery_result_2", "mystery_red");

                madnes_set_text("mystery_result_1_text", madnes_get_text("myst2"));
                madnes_set_text("mystery_result_2_text", madnes_get_text("myst1"));

            }
            if(color == "green")
            {
                madnes_set_texture("mystery_result_1", "mystery_green");
                madnes_set_texture("mystery_result_3", "mystery_red");

                madnes_set_text("mystery_result_1_text", madnes_get_text("myst3"));
                madnes_set_text("mystery_result_3_text", madnes_get_text("myst1"));
            }
        }
        else
        {
            //madnes_set_texture("mystery_btn_1", "mystery_btn_disabled");
        }
        if(pos == 2)
        {
            //madnes_set_texture("mystery_btn_2", "mystery_btn_press");
            if(color == "red")
            {
                madnes_set_texture("mystery_result_2", "mystery_red");
                madnes_set_texture("mystery_result_1", "mystery_gold");

                madnes_set_text("mystery_result_2_text", madnes_get_text("myst1"));
                madnes_set_text("mystery_result_1_text", madnes_get_text("myst2"));
            }
            if(color == "green")
            {
                madnes_set_texture("mystery_result_2", "mystery_green");
                madnes_set_texture("mystery_result_3", "mystery_gold");

                madnes_set_text("mystery_result_2_text", madnes_get_text("myst3"));
                madnes_set_text("mystery_result_3_text", madnes_get_text("myst2"));
            }
        }
        else
        {
            //madnes_set_texture("mystery_btn_2", "mystery_btn_disabled");
        }
        if(pos == 3)
        {
            //madnes_set_texture("mystery_btn_3", "mystery_btn_press");
            if(color == "red")
            {
                madnes_set_texture("mystery_result_3", "mystery_red");
                madnes_set_texture("mystery_result_1", "mystery_green");

                madnes_set_text("mystery_result_3_text", madnes_get_text("myst1"));
                madnes_set_text("mystery_result_1_text", madnes_get_text("myst3"));
            }
            if(color == "gold")
            {
                madnes_set_texture("mystery_result_3", "mystery_gold");
                madnes_set_texture("mystery_result_2", "mystery_green");

                madnes_set_text("mystery_result_3_text", madnes_get_text("myst2"));
                madnes_set_text("mystery_result_2_text", madnes_get_text("myst3"));
            }
        }
        else
        {
            //madnes_set_texture("mystery_btn_3", "mystery_btn_disabled");
        }

        if(pos == 1)
        {
            setTimeout(function() {
                madnes_alpha_to("mystery_result_1_text", 1, 1000);
                madnes_alpha_to("mystery_result_2_text", 0.4, 1000);
                madnes_alpha_to("mystery_result_3_text", 0.4, 1000);
            }, 1000);
        }
        if(pos == 2)
        {
            setTimeout(function() {
                madnes_alpha_to("mystery_result_1_text", 0.4, 1000);
                madnes_alpha_to("mystery_result_2_text", 1, 1000);
                madnes_alpha_to("mystery_result_3_text", 0.4, 1000);
            }, 1000);
        }
        if(pos == 3)
        {
            setTimeout(function() {
                madnes_alpha_to("mystery_result_1_text", 0.4, 1000);
                madnes_alpha_to("mystery_result_2_text", 0.4, 1000);
                madnes_alpha_to("mystery_result_3_text", 1, 1000);
            }, 1000);
        }

    }



    if(ib27_mystery_state == 4.2)
    {
        ib27_mystery_state = 4.3;

        clearTimeout(mystery_btn_dn_timer);
        mystery_btn_dn_timer = null;

        // madnes_fullscreen_enable();
        madnes_audio_play("Explosion_win");
        if(pos == 1)
        {
            madnes_anim_play("mystery_symbol_1", "anim");
        }
        else
        {
            madnes_set_alpha("mystery_symbol_1", 0);
            madnes_set_pos("mystery_symbol_boom_1", 0, 0);
            madnes_set_alpha("mystery_symbol_boom_1", 1);
            madnes_anim_play("mystery_symbol_boom_1", "anim");
        }
        if(pos == 2)
        {
            madnes_anim_play("mystery_symbol_2", "anim");
        }
        else
        {
            madnes_set_alpha("mystery_symbol_2", 0);
            madnes_set_pos("mystery_symbol_boom_2", 0, 0);
            madnes_set_alpha("mystery_symbol_boom_2", 1);
            madnes_anim_play("mystery_symbol_boom_2", "anim");
        }
        if(pos == 3)
        {
            madnes_anim_play("mystery_symbol_3", "anim");
        }
        else
        {
            madnes_set_alpha("mystery_symbol_3", 0);
            madnes_set_pos("mystery_symbol_boom_3", 0, 0);
            madnes_set_alpha("mystery_symbol_boom_3", 1);
            madnes_anim_play("mystery_symbol_boom_3", "anim");
        }
    }
}

export function mystery_btn_end(pos)
{
    madnes_audio_play("Explosion_win");
    madnes_set_alpha("mystery_symbol_" + pos, 0);
    madnes_set_pos("mystery_symbol_boom_" + pos, 0, 0);
    madnes_set_alpha("mystery_symbol_boom_" + pos, 1);
    madnes_anim_play("mystery_symbol_boom_" + pos, "anim");
    ib27_mystery_state = 5;
    ib27_mystery_core();
}
